import React from "react";
import { useController } from "react-hook-form";
import { Text } from "../../../../../../Inputs/react-hook-form";
import { RichText } from "../../../../../../Inputs/RichText";
import {
  getSchemaPropertyFormPath,
  useBuilderFormContext,
} from "../../form/form";
import { FieldsList } from "../FieldsTab/FieldsList";
import { WidgetSettingsContainer } from "./__styles__/WidgetSettings";
import type { InputSettingsFormProps } from "./FieldSettingsView";

export function ObjectFieldTemplateSettings({
  fieldPath,
  isReadOnly,
}: InputSettingsFormProps) {
  const { register } = useBuilderFormContext();

  const titlePropertyFormPath = getSchemaPropertyFormPath(fieldPath, "title");
  const descriptionPropertyFormPath = getSchemaPropertyFormPath(
    fieldPath,
    "description",
  );

  const titleController = useController({
    name: titlePropertyFormPath,
  });
  const descriptionController = useController({
    name: descriptionPropertyFormPath,
  });

  const titleErrorMessage = titleController.fieldState.error?.message;
  const descriptionErrorMessage =
    descriptionController.fieldState.error?.message;

  return (
    <WidgetSettingsContainer>
      <Text
        label="Title"
        error={titleErrorMessage}
        disabled={isReadOnly}
        required
        data-testid="field-group-title-input"
        {...register(titlePropertyFormPath)}
      />
      <RichText
        name={descriptionPropertyFormPath}
        label="Description"
        error={descriptionErrorMessage}
        disabled={isReadOnly}
        value={descriptionController.field.value ?? ""}
        onChange={descriptionController.field.onChange}
      />
      {!isReadOnly && <FieldsList atFieldPath={fieldPath} />}
    </WidgetSettingsContainer>
  );
}
